import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav className="text-gray-600 mt-2">
      <ul className="flex text-sm font-muli-extra-light leading-tight tracking-normal">
        <li>
          <Link to="/" className="text-darkLiver hover:text-black">
            Home
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return (
            <li key={to} className="flex items-center">
              <i className="fa-solid fa-chevron-right text-xs text-darkLiver mx-2" />
              {isLast ? (
                <span className="text-black">{decodeURIComponent(value)}</span>
              ) : (
                <Link to={to} className="text-darkLiver hover:text-black">
                  {decodeURIComponent(value)}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default React.memo(Breadcrumbs);
